import ReactTable from 'react-table';

class BaseTable extends ReactTable {
  setStateWithData(model, callback) {
    return super.setStateWithData(model, () => {
      const { onStateChange } = this.props;
      if (onStateChange) onStateChange(this.state);
      if (callback) callback();
    });
  }
}

export default BaseTable;
